import { useCallback } from 'react';
import { trackEvent } from '@/analytics';
import type { ModalTypes } from '@/components/ModalRenderer/modalMap';
import { AnalyticsEvents } from '@/constants/analytics';
import { transformTrackEventProperties } from '@/hooks/useModal/utils';
import { type OpenModal, useModalStore } from '@/store/modalStore';

type OpenModalOptions = {
  payload?: unknown;
  isPersistedFromRedirect?: boolean;
  confirmAction?: () => void;
  closeAction?: () => void;
};

const useModal = () => {
  const { openModal: openModalFn, closeModal, currentModal, status } = useModalStore();

  const openModal = useCallback(
    (type: ModalTypes, options?: OpenModalOptions) => {
      (openModalFn as (type: ModalTypes, options?: OpenModalOptions) => void)(type, options);

      trackEvent(
        AnalyticsEvents.modalOpen(type),
        options?.payload !== undefined
          ? transformTrackEventProperties({
              payload: options.payload,
            })
          : undefined,
      );
    },
    [openModalFn],
  ) as OpenModal;

  const isModalOpen = status === 'idle' && !!currentModal;

  return { openModal, closeModal, isModalOpen };
};

export default useModal;
